export class PosScanResultDto {
  isValidScreen: boolean;
  currencyCode?: string;
  items: PosItem[];
  subtotal?: number;
  tax?: Tax[];
  fees?: Fees[];
  discounts?: GlobalsDiscount[];
  total?: number;
}

export interface PosItem {
  itemId?: string | null; // Added
  name: string;
  details?: string | null; // Added
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  taxCode?: string | null;
  discounts?: ItemDiscount[];
}

export interface Fees {
  name: string;
  value: number;
  percentage?: number | null;
}

export interface Tax {
  code?: string | null;
  name: string;
  value: number;
  percentage?: number | null;
}

export interface GlobalsDiscount {
  name: string;
  value: number;
  percentage?: number | null;
}

export interface ItemDiscount {
  name: string;
  value: number;
}